<template>
  <div class="modal" :class="{ 'is-active': shown }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Přidat uživatele</p>
        <button class="btn spaceless isGray isCollapsed" @click="closeSelf()">
          <icon type="x" size="16"/>
        </button>
      </header>
      <section class="modal-card-body">
        <table>
          <tr>
            <td>
              <select
                class="select-input"
                :disabled="userType !== 'teacher'"
                v-model="degreeOutcome"
              >
                <option value selected>titul</option>
                <option
                  v-for="(degree, index) in degrees"
                  :value="degree.slug"
                  :key="index"
                >{{ degree.value }}.</option>
              </select>
            </td>
            <td>
              <input
                class="tabled"
                type="text"
                placeholder="jméno"
                v-model="create.firstName"
                @change="resetError"
              >
            </td>
            <td>
              <input
                class="tabled"
                type="text"
                placeholder="příjmení"
                v-model="create.lastName"
                @change="resetError"
              >
            </td>
          </tr>
          <tr>
            <td>
              <input
                type="text"
                class="tabled"
                placeholder="přihlašovací jméno"
                v-model="create.username"
                @change="resetError"
              >
            </td>
            <td>
              <input
                class="tabled"
                type="password"
                placeholder="heslo"
                v-model="create.password"
                @change="resetError"
              >
            </td>
            <td>
              <select
                class="select-input"
                :disabled="userType !== 'student'"
                v-model="classOutcome"
              >
                <option value selected>třída</option>
                <option v-for="(cls, index) in classes" :value="cls" :key="index">{{ cls }}</option>
              </select>
            </td>
          </tr>
        </table>
        <p class="help is-danger" :class="{'visible': error}">{{ errorMessage || '&nbsp;' }}</p>
      </section>
      <footer class="modal-card-foot">
        <div class="level">
          <div class="level-left"></div>
          <div class="level-right">
            <div class="level-item">
              <button class="btn spaceless isGreen" @click="validate()">
                <icon type="check" size="16"/>Potvrdit
              </button>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  props: ['shown', 'userType'],

  data() {
    return {
      degrees: [
        {
          value: 'Mgr',
          slug: 'mgr'
        },
        {
          value: 'Bc',
          slug: 'bc'
        },
        {
          value: 'PhDr',
          slug: 'phdr'
        },
        {
          value: 'RNDr',
          slug: 'rndr'
        },
        {
          value: 'PaedDr',
          slug: 'paeddr'
        },
        {
          value: 'Ing',
          slug: 'ing'
        },
        {
          value: 'BcA',
          slug: 'bca'
        },
        {
          value: 'MgA',
          slug: 'mga'
        }
      ],
      classes: ['Oktáva A', 'Oktáva B', 'Čtvrtá A', 'Čtvrtá B'],
      classOutcome: '',
      degreeOutcome: '',
      create: {
        firstName: '',
        lastName: '',
        username: '',
        password: ''
      },
      error: false,
      errorMessage: ''
    };
  },

  computed: {
    createValues() {
      if (this.create) {
        return Object.values(this.create);
      }
    }
  },

  watch: {
    createValues() {
      this.resetError();
    }
  },

  methods: {
    resetError() {
      this.errorMessage = '';
      this.error = false;
    },

    validate() {
      if (this.userType === 'student' && this.classOutcome === '') {
        this.errorMessage = 'Nebyla přiřazena třída.';
      } else if (this.createValues.includes('')) {
        this.errorMessage = 'Všechna pole nebyla vyplněna.';
      } else if (this.create.username.trim().length < 8) {
        this.errorMessage = 'Uživatelské jméno nedosahuje požadované délky osmi znaků.';
      } else if (this.create.password.trim().length < 8) {
        this.errorMessage = 'Heslo nedosahuje požadované délky osmi znaků.';
      } else if (!/.*[a-z]/.test(this.create.password.trim())) {
        this.errorMessage = 'Heslo neobsahuje žádná malá písmena.';
      } else if (!/.*[A-Z]/.test(this.create.password.trim())) {
        this.errorMessage = 'Heslo neobsahuje žádná velká písmena.';
      } else if (!/\d/.test(this.create.password.trim())) {
        this.errorMessage = 'Heslo neobsahuje žádná čísla.';
      }

      if (this.errorMessage) {
        this.error = true;
      } else {
        const degree = this.degreeOutcome
          ? `${this.degrees.filter(degree => degree.slug === this.degreeOutcome)[0]['value']}.`
          : null;

        const user = {
          username: this.create.username.trim(),
          name: {
            degree,
            firstName: this.create.firstName.trim(),
            lastName: this.create.lastName.trim()
          },
          password: this.create.password.trim(),
          hash: '',
          role: this.userType,
          enabled: this.userType === 'student' ? true : null,
          className: this.classOutcome || null
        };

        this.$emit('beforeAdd', user);
        this.closeSelf();
      }
    },

    closeSelf() {
      this.resetError();

      this.classOutcome = '';
      this.degreeOutcome = '';
      this.create.firstName = '';
      this.create.lastName = '';
      this.create.username = '';
      this.create.password = '';

      this.$emit('closeSelf');
    }
  }
};
</script>

<style lang="sass" scoped>
@import '../styles/select.sass'
@import '../styles/login.sass'
@import '../styles/buttons.sass'

.modal-card-title
  margin-bottom: 0 !important

.modal-card-foot .level
  width: 100%

.modal-card-body
  padding: 40px 20px

.modal-card-body strong
  display: block
  margin-bottom: .5rem

.help
  padding: 0 12px
  opacity: 0

.help.visible
  opacity: 1

td
  border: none !important

table > tr:last-child input
  margin-bottom: 0 !important

.result
  height: 100%

  &, &-box, &-circle
    display: flex
    justify-content: center
    align-items: center

  &-box
    flex-direction: column

  &-circle
    width: 64px
    height: 64px
    border-radius: 50%
    color: white
    margin-bottom: 1rem

  &-success
    background: linear-gradient(to top, #23d160, #2de36d)
    box-shadow: 0px 2px 10px 3px rgba(#23d160 ,.2)
</style>

